<mat-card appearance="outlined" *ngIf="payprin_offload">
    <mat-card-title>{{payprin_offload.title}}</mat-card-title>
    <mat-card-content>
        <div [innerHTML]="payprin_offload.instructions | safeHtml"></div>  
    </mat-card-content>
</mat-card>